export default {
  from: 'De',
  to: 'À',
  enterNameOrNumber: 'Saisir le numéro ou le nom',
  typeMessage: 'Entrer le message...',
  send: 'Envoyer',
};
